import { gtm } from '@greenpanda/svelte-cookies';

export const analytics = gtm('5FZRSX4N');
export const marketing = gtm('WT62W967');
